import React, { useState, createContext } from 'react';

//create context
export const GlobalContext = createContext();

const Context = ({ children }) => {

  //use state
  const [state, setState] = useState({
    mobileNav: false,
    mobilePanel: false,
    darkNav: false
  });

  return (
    <GlobalContext.Provider value={[state, setState]}>
      {children}
    </GlobalContext.Provider>
  );
};

export default Context;